export function getNamePartsFromAccess(
  access?: { fullName?: string | null; firstName?: string | null; lastName?: string | null } | null
) {
  const firstName = access?.firstName?.trim()
  const lastName = access?.lastName?.trim()

  if (firstName || lastName) {
    return {
      firstName: firstName || '',
      lastName: lastName || '',
    }
  }

  const fullName = access?.fullName || ''
  const nameParts = fullName.trim().split(/\s+/).filter(Boolean)

  return {
    firstName: nameParts[0] || '',
    lastName: nameParts.slice(1).join(' ') || '',
  }
}
